import store from '@/store';
import { cifRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import dateToAPI from '@/forms/helpers/date-to-api';
import callApi from '@/lib/helpers/call-api';
import { SET_CIF_NUMBER, SET_APPLICATION_STATUS } from '@/lib/constants/mutations';

const getPayload = () => {
    const { values } = store.state.formData;
    const { appId, productType } = store.state;
    const firstName = getValueByFieldName(values, FIELD_NAMES.firstName);
    const lastName = getValueByFieldName(values, FIELD_NAMES.lastName);
    const email = getValueByFieldName(values, FIELD_NAMES.email);
    const emirateID = getValueByFieldName(values, FIELD_NAMES.emiratesID);
    const phone = getValueByFieldName(values, FIELD_NAMES.phoneNumber);
    const maritalStatus = getValueByFieldName(values, FIELD_NAMES.maritalStatus);
    const gender = getValueByFieldName(values, FIELD_NAMES.gender);

    var phoneNumber = '';
    var areaCode = '';
    const product = getValueByFieldName(values, FIELD_NAMES.product);
    var salesProduct;
    if (product === 'Top Up') {
        salesProduct = 'TOPUP'
    } else if (product === 'New Car' || product === 'Used Car') {
        salesProduct = 'Auto Loan'
    } else {

        salesProduct = product
    }
    phoneNumber = phone.substring(2);
    areaCode = phone.slice(0, 2);
    let title = '';
    if (gender === 'M') {
        title = 'MR.';
    } else if (gender === 'F') {
        title = 'MS.'
    }
    if (product === 'Top Up' || product === 'New Car' || product === 'Used Car') {
        return {
            "app-id": appId,
            "title": title,
            "first-name": firstName,
            "last-name": lastName,
            "mobile-country": "971",
            "mobile-area-code": areaCode,
            "mobile-number": phoneNumber,
            "email-address": email,
            "emirates-id-no": emirateID,
            "activation-flag": "Y",
            "channel": "Onboarding",
            "attribute1": "",
            "attribute2": "",
            "attribute3": "",
            "attribute4": "",
            "attribute5": "",
            "attribute6": salesProduct,
            "attribute7": "",
            "attribute8": "",
            "attribute9": "",
            "attribute10": ""
        };
    }
    return {
        "app-id": appId,
        "title": title,
        "first-name": firstName,
        "last-name": lastName,
        "mobile-country": "971",
        "mobile-area-code": areaCode,
        "mobile-number": phoneNumber,
        "email-address": email,
        "emirates-id-no": emirateID,
        "activation-flag": "Y",
        "channel": "Onboarding",
        "attribute1": "",
        "attribute2": "",
        "attribute3": "",
        "attribute4": "",
        "attribute5": "",
        "attribute6": productType,
        "attribute7": "",
        "attribute8": "",
        "attribute9": "",
        "attribute10": ""

    };
};

export default {
    async getCifNumber(currentStep, callbacks) {
        const { form } = currentStep;
        let response = false;
        response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: cifRepository.getCifNumber,
            payload: getPayload(),
        });
        if (response) {
            if (response['message'] === 'Success') {

                const cifnumber = response['cif-number'];
                const applicationStatus = response['application-status'];
                store.commit(SET_APPLICATION_STATUS, { applicationStatus });
                if (cifnumber) {
                    store.commit(SET_CIF_NUMBER, { cifnumber });
                }
            }
            return response['cif-number'];
        }
    }
};